import { Typography, TypographyProps, useTheme } from '@mui/material';
import Dimens from 'assets/dimens';
import React from 'react';

interface Props extends TypographyProps {
	children: string
}

const TitleLarge: React.FC<Props> = (props) => {
	const theme = useTheme();
	const {
		children, sx,
	} = props;
	return (
		<Typography
			variant="h3"
			{...props}
			sx={{
				fontWeight: Dimens.FONT_BOLDER,
				// lineHeight: {
				// 	lg: Dimens.TEXT_TITLE,
				// 	xl: Dimens.TEXT_TITLE,
				// 	md: Dimens.TEXT_TITLE_LARGE_MOBILE,
				// 	xs: Dimens.TEXT_TITLE_MOBILE,
				// },
				fontSize: {
					lg: Dimens.FONT_SIZE_EXTRA_LARGE,
					xl: Dimens.FONT_SIZE_EXTRA_LARGE,
					md: Dimens.FONT_SIZE_EXTRA_LARGE,
					xs: Dimens.FONT_SIZE_EXTRA_LARGE_MOBILE,
					sm: Dimens.FONT_SIZE_EXTRA_LARGE_MOBILE,
				},
				color: theme.palette.textMain.main,
				...sx,
			}}
		>
			{children}

		</Typography>
	);
};

export default TitleLarge;
